module.exports = __webpack_public_path__ + "img/ETHNIC NECKLACE LIME.11e728c.svg";